import { ThemeType } from "./baseTheme";
import { createMuiTheme } from "@material-ui/core/styles";

// 'AFI' palette of colors
const primaryColor = "#003DA5"; // White
const secondaryColor = "#FFFFFF"; // Blue
const headerTopBorderColor = "#D50032"; // Red
const headerBottomBorderColor = "#BFCADE";
const headerBackgroundColor = "#F0F2F5";
const mainBackgroundColor = "#E5E5E5"; // Very light gray
const listSelectionColor = "#F5F5F5"; // Not so light gray
const footerColor = "#F0F2F5"; // Black
const footerTextColor = "#003DA5";
const footerTopBorderColor = "#FFF"; // Very light gray
const searchButtonBorderRadius = "4px";
const listItemHoverColor = "#E8F0FF";

// Contact number
const contactNumber = "800-280-1466";
// Texts
const footerText = `©2010 - ${new Date().getFullYear()} Permanent General Companies, Inc.`;
const title = "FIND A REPAIR SHOP";
const description =
  "Our 5-Star Repair Program takes the stress out of choosing a repair shop and offers a lifetime workmanship guarantee. \nSearch by city, shop name or ZIP code and connect with a trusted, customer-friendly repair shop near you.";
const noShopsFoundMessage =
  "\nTry searching for another location.\n\nFor immediate repair shop assistance contact claims at " +
  `${contactNumber}`;

export const amfamTheme = createMuiTheme({
  palette: {
    primary: {
      main: `${secondaryColor}`,
    },
  },
  custom: {
    colors: {
      primaryColor: `${primaryColor}`,
      secondaryColor: `${secondaryColor}`,
      headerTopBorderColor: `${headerTopBorderColor}`,
      headerBottomBorderColor: `${headerBottomBorderColor}`,
      headerBackgroundColor: `${headerBackgroundColor}`,
      mainBackgroundColor: `${mainBackgroundColor}`,
      listSelectionBackgroundColor: `${listSelectionColor}`,
      footerBackGroundColor: `${footerColor}`,
      footerTextColor: `${footerTextColor}`,
      footerTopBorderColor: `${footerTopBorderColor}`,
      listItemHoverColor: `${listItemHoverColor}`,
      loadingSpinnerTopColor: `${primaryColor}`,
      loadingSpinnerBottomColor: `${secondaryColor}`,
      loadingSpinnerHeaderColor: `${primaryColor}`,
    },
    text: {
      footerText: `${footerText}`,
      title: `${title}`,
      description: `${description}`,
      contactNumber: `${contactNumber}`,
      noShopsFoundMessage: `${noShopsFoundMessage}`,
    },
    styles: {
      linearProgressBarStyle: {
        borderRadius: "8px",
        primaryBarColor: "#003da5", // Todo: To be updated with the correct Figma value once it becomes available.
        secondaryBarColor: "#e8f0ff", // Todo: To be updated with the correct Figma value once it becomes available.
        header: {
          fontSize: 20,
          fontWeight: 700,
          color: "#384252",
        },
        description: {
          fontSize: 16,
          fontWeight: 400,
          color: "#384252",
        },
      },
      headerSpinner: {
        fontFamily: "Open Sans",
        fontWeight: 700,
        fontSize: "16px",
        color: "#384252",
      },
      headerSecondary: {
        fontFamily: "Open Sans",
        fontWeight: 600,
        fontSize: "28px",
        color: "#384252",
      },
      headerSub: {
        fontFamily: "Open Sans",
        fontWeight: 600,
        fontSize: "20px",
        color: "#384252",
      },
      headerContactUs: {
        fontFamily: "Open Sans",
        fontWeight: 700,
        fontSize: "16px",
        color: "#384252",
      },
      headerTitle: {
        fontFamily: "Oswald",
        fontWeight: 600,
        fontSize: "32px",
        color: "#384252",
      },
      primaryDescription: {
        fontFamily: "Open Sans",
        fontWeight: 400,
        fontSize: "16px",
        color: "#384252",
      },
      secondaryDescription: {
        fontFamily: "Open Sans",
        fontWeight: 400,
        fontSize: "18px",
        color: "#232323",
      },
      linkText: {
        fontFamily: "Open Sans",
        fontWeight: 600,
        fontSize: "16px",
        color: `${primaryColor}`,
        textTransform: "capitalize",
        order: 0,
        "@media (max-width: 480px)": {
          order: 0,
          marginBottom: "13px",
        },
      },
      linkButtonText: {
        fontFamily: "Open Sans",
        fontWeight: 600,
        fontSize: "16px",
        color: `${primaryColor}`,
        textTransform: "capitalize",
        order: 1,
        "@media (max-width: 480px)": {
          order: 1,
          marginBottom: "13px",
        },
      },
      hiddenPadding: "23px",
      rowSpan: {
        order: 0,
        flexGrow: 1,
      },
      themeType: {
        currentThemeType: ThemeType.AMFAM,
      },
      uploadButton: {
        height: "44px",
        textTransform: "none",
      },
      submitButton: {
        order: 2,
        backgroundColor: "#003da5",
        color: "#fff",
        fontSize: "1em",
        fontWeight: 700,
        textTransform: "none",
        borderRadius: `${searchButtonBorderRadius}`,
        "@media (max-width: 480px)": {
          order: 2,
          width: "100%",
          marginRight: "0px !important",
          marginLeft: "0px !important",
          marginBottom: "13px",
        },
        "&:hover": {
          backgroundColor: "#1F66E0",
        },
      },
      iconColor: "#3B4242",
    },
  },
});
